import { render, staticRenderFns } from "./SecurityCandidate.vue?vue&type=template&id=5ab0e894&"
import script from "./SecurityCandidate.vue?vue&type=script&lang=js&"
export * from "./SecurityCandidate.vue?vue&type=script&lang=js&"
import style0 from "./SecurityCandidate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports